import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { useDispatch, useSelector } from "react-redux";
import { getListaGrado } from "../service/FichaEstudiante";

export const FiltroNivelCurso = React.forwardRef(({ getFiltroNivelCurso, reset,todos=true }, ref) => {
    const [valueCurso, setValueCurso] = useState("");
    const [valueSeccion, setValueSeccion] = useState("");

    //Grado Curso
    const [cursoGrado, setCursoGrado] = useState(null);

    //Sección
    const [seccion, setSeccion] = useState(null);
    const [seccionFiltro, setSeccionFiltro] = useState(null);

    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    const labelIni = todos?'--TODOS--':'--SELECCIONAR--'

    useEffect(() => {
        load();
    }, [anio]);

    const load = async () => {
        setValueCurso("");
        setValueSeccion("");

        if (colegio.id !== undefined && anio.anio !== undefined) {
            var data = await getListaGrado(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                let grados = data.grados;
                grados.push({ idnivel: 0,grado: labelIni });
                grados.sort((a, b) => (a.grado > b.grado ? 1 : -1));
                setCursoGrado(grados);
                let seccion = data.seccion;
                seccion.push({ id: 0, seccion: labelIni,idnivel: 0, grado: labelIni });
                seccion.sort((a, b) => (a.seccion > b.seccion ? 1 : -1));
                setSeccion(data.seccion);
            } else {
                if (data.error == 1) {
                    //toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
                    console.log("Error 1");
                } else {
                    console.log("Error");
                }
            }
        } else {
            setCursoGrado([]);
            setSeccionFiltro([]);
        }
    }

    const onChangeCurso = (e) => {
        setValueCurso(e.value);
        setValueSeccion({ id: 0, seccion: labelIni,idnivel: 0, grado: labelIni });
        if (e.value.grado === labelIni) {
            setSeccionFiltro([{ id: 0, seccion: labelIni,idnivel: 0, grado: labelIni }]);
        } else {
            setSeccionFiltro(seccion.filter((o) => o.idnivel == e.value.idnivel || o.seccion == labelIni));
        }
        getFiltroNivelCurso({ es_nivel: true, idnivel: e.value.idnivel, curso: null,id:null });
    }

    const onChangeSeccion = (e) => {
        setValueSeccion(e.value);
        getFiltroNivelCurso({ es_nivel: false, idnivel: valueCurso.idnivel, curso: e.value.seccion,id:e.value.id });
    }

    const resett = () => {
        load();
    }

    return (
        <React.Fragment>
            <div className="p-formgrid p-grid p-col-12 p-md-12 p-lg-12 p-fluid p-p-0">
                <span ref={reset} onClick={resett} visible="false"></span>
                <div className="p-col-12 p-md-6 p-lg-6">
                    <label htmlFor="name3" style={{ fontSize: "12px" }}>
                        Nivel:
                    </label>
                    <Dropdown className="p-button-success mr-2" value={valueCurso} onChange={onChangeCurso} options={cursoGrado} optionLabel="grado" placeholder="--" />
                </div>
                <div className="p-col-12 p-md-6 p-lg-6">
                    <label htmlFor="name5" style={{ fontSize: "12px" }}>
                        Curso:
                    </label>
                    <Dropdown className="p-button-success mr-2" value={valueSeccion} onChange={onChangeSeccion} options={seccionFiltro} optionLabel="seccion" placeholder="--" />
                </div>
            </div>
        </React.Fragment>
    );
});
